import React, { Component } from 'react';
import { Field } from 'redux-form';

import PasswordStrength from "../passwordStrength";
import './formElements.css';
import './formToggle.css';
import './formPasswordStrength.css';

export const ShortField = ({ input, label, placeholder, type, meta: { touched, error }, iniValue }) => (
  <div className='fieldWrapper'>
    <label htmlFor={label}>{label}</label>
    <input id={label} type={type} placeholder={placeholder} value={iniValue} {...input} ></input>
    <div className="error">{touched && error ? error : ''}</div>
  </div>
)

export const ShortFieldIcon = ({ input, label, placeholder, type, meta: { touched, error }, icon }) => (
  <div className='fieldWrapper'>
    <label htmlFor={label}>{label}</label>
    <div className='fieldWithIcon'>
      <input id={label} type={type} {...input} placeholder={placeholder} ></input>
      <span className={`end mdi mdi-${icon}`}></span>
    </div>
    <div className="error">{touched && error ? error : ''}</div>
  </div>
)
export const ShortFieldText = ({ input, label, placeholder, type, meta: { touched, error }, textEnd }) => (
  <div className='fieldWrapper'>
    <label htmlFor={label}>{label}</label>
    <div className='fieldWithText'>
      <input id={label} type={type} {...input} placeholder={placeholder} ></input>
      <span className='end'>{textEnd}</span>
    </div>
    <div className="error">{touched && error ? error : ''}</div>
  </div>
)

export const AddField = ({ input, label, placeholder, type, meta: { touched, error }, iniValue }) => (
  <div className='fieldWrapper listInput'>
    <input id={label} type={type} placeholder={placeholder} value={iniValue} {...input} ></input>
  </div>
)

export const LongField = ({ input, label, placeholder, type, meta: { touched, error }, iniValue }) => (
  <div className='fieldWrapper'>
    <label htmlFor={label}>{label}</label>
    <textarea id={label} className='long' type={type} {...input} value={iniValue} placeholder={placeholder} ></textarea>
    <div className="error">{touched && error ? error : ''}</div>
  </div>
)

export const PasswordRegister = ({ input, label, type, screen, meta: { touched, error } }) => (
  <div className='fieldWrapper'>
    <label htmlFor={label}>{label}</label>
    <input id={label} type={type} {...input} ></input>
    <div className="error">{touched && error ? error : ''}</div>
    <div id='passwordStrengthWrapper'>{screen === 'register' ? <PasswordStrength input={input} /> : '' }</div>
  </div>
)

export const Toggle = ({ input, label, type, meta: { touched, error } }) => (
  <div className='fieldWrapper toggleWrapper'>
    <label htmlFor={label}>{label}</label>
    <label className="toggle">
      <input id={label} className='input' type='checkbox' {...input} ></input>
      <span className="slider"></span>
    </label>
  </div>
)

export const Number = ({ input, label, type, meta: { touched, error } }) => (
  <div className='fieldWrapper'>
    <div className='flex'>
      <label htmlFor={label}>{label}</label>
      <input id={label} type='number' {...input} />
    </div>
  </div>
)

export class Shortcuts extends Component {
  render() {
    const { fields, meta: { touched, error, submitFailed }} = this.props;
    return(
      <div className='shortcuts'>

        {touched && error && <span className="error">{error}</span>}
        {fields.map((item, index) =>
          <div key={index} className='item'>
            <Field label='Title' name={`${item}.title`} type="text" component={ShortField} />
            <Field label='Link' name={`${item}.link`} type="text" component={ShortField} />
          </div>
        )}
        {fields.length <= 5 ? (
          <button type="button"  onClick={() => fields.push({})}>
            <span className='mdi mdi-plus' />
            <span className='btnLabel'>Add shortcut </span>
          </button>
        ) : null }

      </div>
    )
  }
}
